import React from 'react';
import { SignIn } from '@clerk/clerk-react';
import { Box, Typography, Container, Paper, Button } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';

export const ApiLimitReached: React.FC = () => {
  const theme = useTheme();
  const contactTint = alpha(theme.palette.primary.main, 0.1);
  const contactBorder = alpha(theme.palette.primary.main, 0.32);

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          py: 4,
        }}
      >
        <Paper
          elevation={3}
          sx={{
            p: 4,
            width: '100%',
            textAlign: 'center',
            borderRadius: 2,
          }}
        >
          <Typography variant="h4" component="h2" gutterBottom sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 2 }}>
            <Box
              component="img"
              src="/favicon.svg"
              alt="TripGen AI Logo"
              sx={{ 
                width: '2rem',
                height: '2rem',
                display: 'block'
              }}
            />
            TripGenAI
          </Typography>
          
          <Box sx={{ display: 'flex', justifyContent: 'center', mb: 4 }}>
            <SignIn />
          </Box>

          {/* Developer Contact Information */}
          <Box sx={{ 
            p: 3, 
            backgroundColor: contactTint, 
            borderRadius: 2,
            border: `1px solid ${contactBorder}`
          }}>
            <Typography variant="h6" sx={{ color: 'primary.main', fontWeight: 'bold', mb: 2 }}>
              👨‍💻 Get in Touch
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              Built by{' '}
              <Button
                variant="text"
                href="https://www.linkedin.com/in/nikita-baklazhenko/"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  textTransform: 'none',
                  fontWeight: 'bold',
                  color: 'primary.main',
                  textDecoration: 'underline',
                  p: 0,
                  minWidth: 'auto',
                  '&:hover': {
                    backgroundColor: 'transparent',
                    textDecoration: 'underline',
                    color: '#0077b5'
                  }
                }}
              >
                Baklazhenko Nikita
              </Button>
              , Data Scientist & ML Engineer. AI requests have operational costs, so free usage is limited. Feel free to reach out if you have any questions, concerns, found bugs, or want to collaborate on any projects.
            </Typography>
            <Box sx={{ 
              display: 'flex', 
              gap: 2, 
              justifyContent: 'center', 
              alignItems: 'center',
              flexWrap: 'wrap',
              mt: 2
            }}>
              <Button
                variant="outlined"
                size="small"
                startIcon={<Typography variant="body1">💼</Typography>}
                href="https://www.linkedin.com/in/nikita-baklazhenko/"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  borderColor: '#0077b5',
                  color: '#0077b5',
                  '&:hover': {
                    backgroundColor: '#0077b5',
                    color: 'white'
                  }
                }}
              >
                LinkedIn
              </Button>
              <Button
                variant="outlined"
                size="small"
                startIcon={<Typography variant="body1">✉️</Typography>}
                href="mailto:nikita.baklazhenko@bse.eu"
                sx={{
                  borderColor: '#ea4335',
                  color: '#ea4335',
                  '&:hover': {
                    backgroundColor: '#ea4335',
                    color: 'white'
                  }
                }}
              >
                Email
              </Button>
            </Box>
            <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
              nikita.baklazhenko@bse.eu
            </Typography>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
}; 
